<template>
    <footer class="footer">
        <div class="footer__top py-16">
            <v-container class="container--sm">
                <v-row align="center" class="row--small footer__link">
                    <v-col cols="auto">
                        <v-btn text x-small color="grey-6" to="/center">
                            <span class="font-weight-regular">공지사항</span>
                        </v-btn>
                    </v-col>
                    <v-col class="d-none d-md-block" cols="auto"><span class="menu-line"></span></v-col>
                    <v-col cols="auto">
                        <v-btn text x-small color="grey-6" to="/center/faqs">
                            <span class="font-weight-regular">자주묻는질문</span>
                        </v-btn>
                    </v-col>
                    <v-col class="d-none d-md-block" cols="auto"><span class="menu-line"></span></v-col>
                    <v-col cols="auto">
                        <v-btn text x-small color="grey-6" to="/service-policy">
                            <span class="font-weight-regular">이용약관</span>
                        </v-btn>
                    </v-col>
                    <v-col class="d-none d-md-block" cols="auto"><span class="menu-line"></span></v-col>
                    <v-col cols="auto">
                        <v-btn text x-small color="grey-6" to="/privacy-policy">
                            <span class="font-weight-regular">개인정보처리방침</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div class="footer__bottom py-48">
            <v-container class="container--sm">
                <v-row align-md="center">
                    <v-col cols="12" lg="auto" class="mb-6 mb-lg-0">
                        <v-img src="/images/ci.svg" class="w-120px w-lg-200px"></v-img>
                    </v-col>
                    <v-col cols="12" lg="" class="ml-xl-56">
                        <p class="page-text grey-9--text mb-lg-8">
                            <span class="grey-6--text">회사명</span> 주식회사 디엔아이씨<span class="text-center d-none d-md-inline-block" style="width: 16px"></span><br class="d-block d-md-none">
                            <span class="grey-6--text">주소</span> 서울시 영등포구 양평로 22길 21, 1406호<span class="text-center d-none d-md-inline-block" style="width: 16px"></span><br class="d-block d-md-none">
                            <span class="grey-6--text">대표자명</span> 유지수
                        </p>
                        <p class="page-text grey-9--text">
                            <span class="grey-6--text">사업자등록번호</span> 105-86-25713<span class="text-center d-none d-md-inline-block" style="width: 16px"></span><br class="d-block d-md-none">
                            <span class="grey-6--text">통신판매업신고증</span> 제 2022-서울영등포-3202호<span class="text-center d-none d-md-inline-block" style="width: 16px"></span><br class="d-block d-md-none">
                            <span class="grey-6--text">전화</span> 02)325-9123<span class="text-center d-none d-md-inline-block" style="width: 16px"></span><br class="d-block d-md-none">
                            <span class="grey-6--text">이메일</span> support@micepec.com <br>
                        </p>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </footer>
</template>

<script>
// import UScrollTop from "@/components/dumb/u-scroll-top.vue";
import DialogLogin from "@/components/client/login/dialog-login.vue";

export default {
    components: {
        // UScrollTop,
        DialogLogin
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
    },
    data() {
        return {
        };
    },
};
</script>

<style scoped>
.footer {
    font-size: 1.4rem;
}
.footer .container{
    max-width: calc(var(--container-lg) + 12px*2);
}
.footer__top{
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
}
.footer__link{
    position: relative;
    left: -8px;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}
</style>
